/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * Module for all things gslb related.
 * @preferred
 * @module GslbModule
 */

import {
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
    NO_ERRORS_SCHEMA,
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { SharedModule } from 'ng/shared/shared.module';
import { DataGridModule } from 'ng/modules/data-grid/data-grid.module';
import { AviFormsModule } from 'ng/modules/avi-forms/avi-forms.module';
import { CoreModule } from 'ng/modules/core/core.module';

import {
    GslbAviSiteConfigComponent,
    GslbClientIpAddrGroupConfigComponent,
    GslbDnsVirtualServicesGridComponent,
    GslbGeoLocationConfigComponent,
    GslbHealthMonitorProxyGridComponent,
    GslbIpAddressGridComponent,
    GslbPoolMemberDomainNameComponent,
    GslbPoolMemberTypeComponent,
    GslbPoolMemberVirtualServiceComponent,
    GslbServiceDomainNamesGridComponent,
    GslbServiceGeoLocationComponent,
    GslbServiceHealthMonitorsGridComponent,
    GslbServiceModalComponent,
    GslbServicePoolMemberModalComponent,
    GslbServicePoolMembersGridComponent,
    GslbServicePoolModalComponent,
    GslbServicePoolsGridComponent,
    GslbSettingModalComponent,
    GslbSiteDnsVsModalComponent,
    GslbSiteEditCredentialsDialogComponent,
    GslbSiteModalComponent,
    GslbSitePreviewComponent,
    GslbSubdomainsGridComponent,
    GslbThirdPartySiteConfigComponent,
} from '.';

import {
    gslbGeoDbProfileCollectionProvider,
    gslbServiceCollectionProvider,
} from './ajs-upgraded-providers';

const gslbComponents = [
    GslbClientIpAddrGroupConfigComponent,
    GslbDnsVirtualServicesGridComponent,
    GslbSettingModalComponent,
    GslbSiteDnsVsModalComponent,
    GslbSiteModalComponent,
    GslbPoolMemberDomainNameComponent,
    GslbPoolMemberTypeComponent,
    GslbPoolMemberVirtualServiceComponent,
    GslbServiceDomainNamesGridComponent,
    GslbServiceGeoLocationComponent,
    GslbServiceHealthMonitorsGridComponent,
    GslbServiceModalComponent,
    GslbServicePoolMemberModalComponent,
    GslbServicePoolMembersGridComponent,
    GslbServicePoolModalComponent,
    GslbServicePoolsGridComponent,
    GslbSitePreviewComponent,
    GslbSiteEditCredentialsDialogComponent,
    GslbHealthMonitorProxyGridComponent,
    GslbIpAddressGridComponent,
    GslbAviSiteConfigComponent,
    GslbGeoLocationConfigComponent,
    GslbThirdPartySiteConfigComponent,
    GslbSubdomainsGridComponent,
];

@NgModule({
    declarations: [
        ...gslbComponents,
    ],
    imports: [
        AviFormsModule,
        CommonModule,
        CoreModule,
        DataGridModule,
        SharedModule,
    ],
    providers: [
        gslbGeoDbProfileCollectionProvider,
        gslbServiceCollectionProvider,
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA,
    ],
})
export class GslbModule {}
